import {IAddress} from '@/types/common';

export const isPasskeyWallet = (address: IAddress) =>
  address.isPasskey && address.isWallet;
